import { render, staticRenderFns } from "./audit-withdraw.vue?vue&type=template&id=6d2c4a9c&scoped=true&"
import script from "./audit-withdraw.vue?vue&type=script&lang=js&"
export * from "./audit-withdraw.vue?vue&type=script&lang=js&"
import style0 from "./audit-withdraw.vue?vue&type=style&index=0&id=6d2c4a9c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d2c4a9c",
  null
  
)

export default component.exports